import { useEffect, useRef } from 'react'

// Nach einem Routenwechsel liest ein Screenreader nichts von selbst — der Fokus
// auf die Überschrift des neuen Bereichs macht den Wechsel hörbar. Nur beim
// Übergang nach "bereit", nicht bei jedem Rendern.
//
// preventScroll: wer die Stelle selbst ins Bild bringt (der Slider des
// MatchMeista), fokussiert ohne Scrollen. Sonst scrollte der Browser das
// Slider-Fenster zusaetzlich zur Animation, und die Frage verschwand (#220).
export const useFocusHeading = (bereit, { preventScroll = false } = {}) => {
    const ref = useRef(null)
    const vorher = useRef(false)

    useEffect(() => {
        if (bereit && !vorher.current && ref.current) {
            if (preventScroll) ref.current.focus({ preventScroll: true })
            else ref.current.focus()
        }
        vorher.current = bereit
    }, [bereit])

    return ref
}
